import script from "./ExecutionsTransfer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExecutionsTransfer.vue?vue&type=script&setup=true&lang=ts"

import "./ExecutionsTransfer.vue?vue&type=style&index=0&id=21d5c878&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d5c878"]])

export default __exports__